export default __webpack_public_path__ + "static/media/phone.b75528ae.svg";